import { I18nComponente } from "@/types/gerais"

export const ListarAtividadesi18n: I18nComponente = {
  "pt-BR": {
    recursos: "recursos",
    tiposDeRecursos: "tipos de recursos",
    criarTipoDeRecurso: "criar tipo de recurso",
    recursoCriado: "recurso criado",
    tipoDeRecursoNaoCriado: "tipo de recurso não criado",
    tipoDeRecursoVazio: "NovoTipoRecurso: Tipo de Recurso vazio",
    preenchaOsCamposObrigatorios: "Preencha os campos obrigatórios",
    erroAoCarregarEventosDoCalendario: "Erro ao carregar eventos do calendário",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Ao cancelar você perderá todas as informações não salvas",
    cancelar: "cancelar",
    criacao: "criação",
    edicao: "edição",
    deTipoDeRecurso: "de tipo de recurso?",
    voltar: "voltar",
    simCancelar: "sim, cancelar",
  },
  "es-CO": {
    recursos: "recursos",
    tiposDeRecursos: "tipos de recursos",
    criarTipoDeRecurso: "añadir tipo de recurso",
    recursoCriado: "recurso creado",
    tipoDeRecursoNaoCriado: "tipo de recurso no creado",
    tipoDeRecursoVazio: "NovoTipoRecurso: Tipo de Recurso vacío",
    preenchaOsCamposObrigatorios: "Rellene los campos obligatorios",
    erroAoCarregarEventosDoCalendario: "Error al cargar eventos del calendario",
    aoCancelarVocePerderaTodasAsInformacoesNaoSalvas: "Al cancelar perderá toda la información no guardada",
    cancelar: "cancelar",
    criacao: "creación",
    edicao: "edición",
    deTipoDeRecurso: "de tipo de recurso?",
    voltar: "volver",
    simCancelar: "sí, cancelar",
  }
}
